// src/modules/leads/route-planner/LeadSelectionCard.js
import React from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaPlus, FaMinus } from 'react-icons/fa';
import formatPhone from '../../../components/shared/formatPhone';
import OriginBadge from '../../../components/shared/OriginBadge';
import {
  LeadCard, CardHeader, CardName, CardStatus,
  CardInfo, CardActions, ActionButton,
} from './routePlannerStyles';

const LeadSelectionCard = ({ lead, isSelected, isAlongRoute, onToggle, onAdd, onClick }) => {
  const statusName = lead.status?.status_name || lead.serviceRequests?.[0]?.LeadStatus?.status_name || 'No Status';
  const statusColor = lead.status?.color || '#95a5a6';
  const hasCoords = lead.latitude && lead.longitude;

  return (
    <LeadCard
      statusColor={isAlongRoute ? '#9b59b6' : statusColor}
      isHighlighted={isSelected}
      onClick={() => onClick?.(lead)}
      style={!hasCoords ? { opacity: 0.4, pointerEvents: 'none' } : undefined}
    >
      <CardHeader>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', minWidth: 0 }}>
          <CardName>{lead.name}</CardName>
          {lead.origin?.origin_name && (
            <OriginBadge origin={lead.origin} size="sm" />
          )}
        </div>
        <CardStatus color={statusColor}>{statusName}</CardStatus>
      </CardHeader>

      <CardInfo>
        <FaMapMarkerAlt />
        {lead.city || 'No city'}{lead.state ? `, ${lead.state}` : ''}
      </CardInfo>

      <CardInfo>
        <FaPhoneAlt />
        {formatPhone(lead.phone) || 'No phone'}
      </CardInfo>

      {!hasCoords && (
        <CardInfo style={{ color: '#e74c3c', fontSize: '0.7rem' }}>
          No location data
        </CardInfo>
      )}

      {hasCoords && (
        <CardActions>
          {isAlongRoute ? (
            <ActionButton
              variant="primary"
              onClick={(e) => { e.stopPropagation(); onAdd?.(lead.id); }}
            >
              <FaPlus /> Add to Route
            </ActionButton>
          ) : isSelected ? (
            <ActionButton
              variant="danger"
              onClick={(e) => { e.stopPropagation(); onToggle?.(lead.id); }}
            >
              <FaMinus /> Remove
            </ActionButton>
          ) : (
            <ActionButton
              variant="primary"
              onClick={(e) => { e.stopPropagation(); onToggle?.(lead.id); }}
            >
              <FaPlus /> Add to Route
            </ActionButton>
          )}
        </CardActions>
      )}
    </LeadCard>
  );
};

export default LeadSelectionCard;
